<template>
  <div>
    <template v-if="!isEmpty(selectedTrips)">
      <div
        v-for="(trip, indexTrips) of selectedTrips"
        :key="indexTrips"
        class="mb-25 pl-50 border-secondary rounded-lg hover-bg-light-warning"
      >
        <b-form-checkbox
          v-model="trip.isChecked"
          class="custom_checkbox_selectedTrip"
        >
          <div class="d-flex-between">
            <div class="fw-700">
              {{ indexTrips + 1 }}
            </div>
            <div class="d-flex flex-column mx-25">
              <div
                v-for="(segment, indexSegment) in trip.segments"
                :key="indexSegment"
                :class="`fw-700 d-flex flex-wrap gap-1 ${ !['lg', 'xl'].includes(appBreakPoint) ? 'font-small-4' : 'font-medium-1' } `"
              >
                <!-- {{ getSortTripBySegment(segment, true) }} -->
                <span>{{ `${segment.airline}${segment.flightNumber}` }}</span>
                <span :class="segment.bookingClass.changed ? 'text-danger' : '' ">{{ segment.bookingClass.code }}</span>
                <span>{{ convertISODateTime(segment.departureDate, segment.departureTimezone).dayMonth }}</span>
                <span>{{ `${segment.departure}${segment.arrival}` }}</span>
                <span>{{ ['LL'].includes(segment?.bookingClass?.status) ? 'HL' : ['NN'].includes(segment?.bookingClass?.status) ? `${segment?.bookingClass?.status}${segment?.bookingClass?.availability}` : (segment?.bookingClass?.status || '') }}</span>
                <span>{{ `${convertISODateTime(segment?.departureDate, segment?.departureTimezone).hourMin} ${convertISODateTime(segment?.arrivalDate, segment?.arrivalTimezone).hourMin}` }}</span>
                <span>{{ segment.airCraft }}</span>
              </div>
            </div>
            <div>
              <b-button
                variant="flat-danger"
                class="p-50"
                @click.stop="deleteTripHandle(trip.selectedTripId)"
              >
                <feather-icon
                  class="cursor-pointer"
                  icon="XIcon"
                  size="18"
                />
              </b-button>
            </div>
          </div>
        </b-form-checkbox>
      </div>
    </template>
    <div
      v-else
      class="text-warning font-italic mx-1"
    >
      Chưa chọn chuyến bay
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormCheckbox,
} from 'bootstrap-vue'
import { isEmpty } from 'lodash-es'
// import {
//   onBeforeUpdate,
// } from '@vue/composition-api'

import { convertISODateTime } from '@/@core/utils/filter'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BButton,
    BFormCheckbox,
  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingProBookTrip' ")
    // })

    const {
      selectedTrips,
      deleteTripHandle,
      getSortTripBySegment,
    } = useClassBookingPro()

    return {
      selectedTrips,
      isEmpty,
      convertISODateTime,
      getSortTripBySegment,
      deleteTripHandle,
    }
  },
}
</script>

<style lang="scss">
.custom_checkbox_selectedTrip {
  .custom-control-label {
    width: 100%;
  }
}
</style>
